import React from "react";
import toolstyles from "./Tooltip.module.scss";
import ReactTooltip from "react-tooltip";
import { ReactComponent as Help } from "../../assets/logos/help-icon.svg";

const Tooltip = (props) => {
  const hasClickAction = typeof props.onClick === "function";
  
  const handleClick = (e) => {
    if (hasClickAction) {
      e.stopPropagation();
      props.onClick(e);
    }
  };

  const tooltipGroupClass = props.inline 
    ? `${toolstyles.toolgroup} ${toolstyles.inline}`
    : toolstyles.toolgroup;

  return (
    <div className={tooltipGroupClass} style={props.style} data-testid={props["data-testid"] || null}>
      <i
        className={
          props.dark
            ? `${toolstyles.infoIcon} ${toolstyles.dark} ${hasClickAction ? toolstyles.clickable : ""}`
            : `${toolstyles.infoIcon} ${toolstyles.light} ${hasClickAction ? toolstyles.clickable : ""}`
        }
        data-for={props.id}
        data-tip
        onClick={handleClick}
        role={hasClickAction ? "button" : undefined}
        tabIndex={hasClickAction ? 0 : undefined}
        onKeyPress={hasClickAction ? (e) => {
          if (e.key === "Enter" || e.key === " ") {
            handleClick(e);
          }
        } : undefined}
      >
        {" "}
        <Help />{" "}
      </i>
      {props.content && (
        <ReactTooltip
          className={
            props.dark
              ? `${toolstyles.tooltipInstance} ${toolstyles.dark}`
              : `${toolstyles.tooltipInstance} ${toolstyles.light}`
          }
          id={props.id}
          delayHide={props.delay || 0}
          type="dark"
          effect="solid"
          place={props.place || "top"}
          clickable={hasClickAction}
        >
          <div className={toolstyles.tooltipText}>{props.content}</div>
        </ReactTooltip>
      )}
    </div>
  );
};

export default Tooltip;
